import React from "react";

export default function SheildIcon() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="12" fill="#00B136" fillOpacity="0.08" />
      <path
        opacity="0.32"
        d="M20.6462 14.2683L16.4814 16.1194C15.2767 16.6548 14.4817 17.8538 14.5584 19.1699C14.8581 24.3151 16.3648 26.5803 20.2799 29.2308C21.3171 29.9329 22.6841 29.9347 23.7206 29.2313C27.6477 26.5663 29.1005 24.2693 29.4266 19.1877C29.5116 17.863 28.7152 16.6512 27.5021 16.1121L23.3538 14.2683C22.492 13.8853 21.5081 13.8853 20.6462 14.2683Z"
        fill="#00B136"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9116 19.863C25.1713 20.0903 25.1977 20.4852 24.9704 20.7449L22.5788 23.4782C22.0649 24.0655 21.1797 24.1441 20.5702 23.6566L19.1096 22.4881C18.84 22.2724 18.7963 21.8791 19.012 21.6096C19.2276 21.34 19.6209 21.2963 19.8905 21.512L21.3512 22.6805C21.4382 22.7502 21.5647 22.7389 21.6381 22.655L24.0297 19.9218C24.257 19.662 24.6518 19.6357 24.9116 19.863Z"
        fill="#00B136"
      />
    </svg>
  );
}
